import React, { useState, useRef } from 'react';

import { IcSettings24Icon } from '@gem/icons';
import { IconButton, Popover } from '@gem/ui-kit';

import { ICalendarAuthAccount } from 'APP/model/calendar/calendar.types';

import { ExternalEmails } from './ExternalEmails';
import styles from './Setting.styles.m.css';
import { SwitchCompactView } from './SwitchCompactView';

interface ISettingProps {
  accounts: ICalendarAuthAccount[];
}

export const Setting: React.FC<ISettingProps> = ({ accounts }) => {
  const anchorRef = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const onOpen = (): void => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <IconButton
        Icon={IcSettings24Icon}
        onClick={onOpen}
        setRef={anchorRef}
        dataTest="calendar-settings-button"
      />
      <Popover
        isOpened={isOpen}
        onClose={onOpen}
        reference={anchorRef.current}
        placement="bottom-end"
        className={styles.popover}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 0] },
          },
        ]}
      >
        <>
          <SwitchCompactView />
          <div className={styles.divider} />
          <ExternalEmails accounts={accounts} />
        </>
      </Popover>
    </>
  );
};
